import { render, staticRenderFns } from "./dataDisplay.vue?vue&type=template&id=0f0fdab0&scoped=true"
import script from "./dataDisplay.vue?vue&type=script&lang=js"
export * from "./dataDisplay.vue?vue&type=script&lang=js"
import style0 from "./dataDisplay.vue?vue&type=style&index=0&id=0f0fdab0&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f0fdab0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0f0fdab0')) {
      api.createRecord('0f0fdab0', component.options)
    } else {
      api.reload('0f0fdab0', component.options)
    }
    module.hot.accept("./dataDisplay.vue?vue&type=template&id=0f0fdab0&scoped=true", function () {
      api.rerender('0f0fdab0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/operationManagement/appNewRenovation/userCenter/components/dataDisplay.vue"
export default component.exports